const React = require("react");

module.exports = ({index, className, ...rest}) => {
  return (
    <div
      {...rest}
      className={
        `w layoutRow fhaS fvaC h60 bxzBorderBox rlv lh fw7 f12 c2 tl lts0em bgFAFAFA.hasBg
                    (pt19|pr10|pb23|pl19)>1`
        + ((index + 1) % 2 === 0 ? ' hasBg' : '')
        + (className ? ` ${className}` : '')
      }
    />
  )
}